import React, { useRef, useState } from "react";
import { formatYoutubeVideo } from "~/common/utils/formatYoutubeVideo";
import styles from "./light-box.module.css";
import Flicking from "@egjs/react-flicking";
import { LazyVideo } from "@components-monorepo/components/Video/lazy-video";
import { useArrows } from "@components-monorepo/components/products-slider/hooks";
import { ITheme } from "@commons-monorepo/index";
import { UiArrow } from "@ui-monorepo/index";
import ImageZoom from "../image-zoom";

interface LightBoxProps {
  images: string[];
  videosUrl?: string;
  close: () => void;
  indexPhotos: number;
  theme: ITheme;
  log: (source: string, option: string) => void;
  storeMetadata: any;
}

const LightBoxGallery = ({
  images,
  videosUrl,
  close,
  indexPhotos,
  log,
  theme,
  storeMetadata
}: LightBoxProps) => {
  const [currentIndex, setCurrentIndex] = useState(indexPhotos);
  const flickingRef = useRef<Flicking>(null);
  const { next, prev } = useArrows(flickingRef);
  const onClose = () => {
    close();
  };

  const onZoomImage = (zoom: boolean) => {
    if (flickingRef.current) {
      if (zoom) {
        flickingRef.current.disableInput();
      } else {
        flickingRef.current.enableInput();
      }
    }
  };

  return (
    <div>
      {!!images.length &&
      <div className={styles.lightbox}>
          <div className={styles.close} onClick={onClose}>
            <figure className={"icon-close"} />
          </div>
          <UiArrow
          className={styles.left}
          onClick={() => {
            prev();
            log("product_detail_image", "slider_arrows");
          }}
          visibility={images.length > 1 || !!videosUrl ? "visible" : "hidden"}
          icon={"icon-arrow-black"} />

          <div className={styles.box}>
            <Flicking
            ref={flickingRef}
            className={styles.slider}
            cameraClass={styles.camera}
            defaultIndex={indexPhotos}
            panelsPerView={1}
            noPanelStyleOverride={true}
            align={"center"}
            circular={true}
            onChanged={(e) => {
              setCurrentIndex(e.currentTarget.index);
            }}>

              {images.map((image: string, index: number) =>
            <div
              key={`${index}-${image}-lightBox`}
              className={styles.lightboxImg}>

                  <ImageZoom image={image} onChangeZoom={onZoomImage} />
                </div>
            )}
              {videosUrl !== "" &&
            videosUrl !== undefined &&
            images?.length &&
            <div
              aria-label='video-content'
              key={`${images?.length}-456-video-content}-lightBox`}
              className={`${styles.videoThumb}`}>

                    <LazyVideo
                videoUrl={formatYoutubeVideo(videosUrl)}
                className='sliderProduct2'
                theme={theme}
                storeMetadata={storeMetadata} />

                  </div>}

            </Flicking>
            {images?.length > 1 &&
          <div className={styles.counter}>
                {currentIndex + 1} /{" "}
                {(images?.length || 0) + (videosUrl ? 1 : 0)}
              </div>}

          </div>
          <UiArrow
          className={styles.right}
          onClick={() => {
            next();
            log("product_detail_image", "slider_arrows");
          }}
          visibility={images.length > 1 || !!videosUrl ? "visible" : "hidden"}
          icon={"icon-arrow-black"} />

        </div>}

    </div>);

};

export default LightBoxGallery;